import axios, { AxiosInstance } from 'axios';

import { resolveXSiteIntegrationDomain } from '../../utils/core/endpoints';
import { isDefined } from '../../utils/variables';
import { AuthenticationServiceV1 } from './services/xsite/v1/authentication-service';
import { SkyMapXsiteConnectionServiceV1 } from './services/xsite/v1/skymap-xsite-connection-service';

class XsiteAxiosServiceFactory {
  static get instance() {
    if (!isDefined(XsiteAxiosServiceFactory.axiosInstance)) {
      XsiteAxiosServiceFactory._instance.setup();
    }
    return XsiteAxiosServiceFactory._instance;
  }

  /**
   *  Because axiosInstance is not setup until setup, it is possible undefined.
   *  TODO: Remove dependency to
   */
  private static axiosInstance?: AxiosInstance;

  private static _instance: XsiteAxiosServiceFactory = new XsiteAxiosServiceFactory();

  /**
   *  Intercepts any error when executing requests. Prints the error and throws a promise rejection.
   * @param error
   */
  static requestErrorInterceptor(error: any) {
    return Promise.reject(error);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  /**
   *  Setup axios factory with the base url and token service.
   * @param url - The API base url.
   */
  setup() {
    XsiteAxiosServiceFactory.axiosInstance = axios.create({
      baseURL: resolveXSiteIntegrationDomain(),
      maxRedirects: 0,
    });

    XsiteAxiosServiceFactory.axiosInstance.interceptors.request.use(
      void XsiteAxiosServiceFactory.requestErrorInterceptor,
    );

    XsiteAxiosServiceFactory.axiosInstance.interceptors.response.use(
      (value) => value,
      (error) => Promise.reject(error),
    );
  }

  createAuthenticationServiceV1() {
    return new AuthenticationServiceV1(XsiteAxiosServiceFactory.axiosInstance!);
  }

  createSkyMapXsiteConnectionServiceV1() {
    return new SkyMapXsiteConnectionServiceV1(XsiteAxiosServiceFactory.axiosInstance!);
  }
}

export { XsiteAxiosServiceFactory };
